import {isTracing, traceValue_} from "./foreign.js";
const traceValue = dictMonadEffect => dictEncode => name => value => dictMonadEffect.liftEffect(traceValue_(name)(dictEncode.encode(value)));
const ifTracing = dictMonadEffect => {
  const $0 = dictMonadEffect.Monad0();
  const $1 = dictMonadEffect.liftEffect(isTracing);
  return m => $0.Bind1().bind($1)(b => {
    const $2 = $0.Applicative0();
    if (b) { return m; }
    return $2.pure();
  });
};
export {ifTracing, traceValue};
export * from "./foreign.js";
